import axios from './axios';

export const fetchWallets = async (exchange = 'TW') => {
  const res = await axios({
    method: 'GET',
    url: `/api/wallets?exchange=${exchange}`,
  });

  return res.data;
};
